export const getTitle = (str) => {
  const arr = str.split("&");
  return arr.pop();
};

export const getAddress = (str) => {
  const arr = str.split("&");
  const newStr = arr[2].replace(/улица/gi, "ул.");
  const newStr2 = newStr.replace(/Россия,/gi, "");
  const newArr = newStr2.split(",").filter((el) => {
    if (el.includes("область")) {
      return false;
    } else if (el.includes("край")) {
      return false;
    } else if (el.includes("округ")) {
      return false;
    } else {
      return true;
    }
  });

  return newArr.join(",");
};

export const getCoord = (str) => {
  const arr = str.split("&");
  arr.pop();
  return arr;
};
